import { Button as MUIButton, ButtonProps as MUIButtonProps, styled, CircularProgress } from '@mui/material';

export interface ButtonProps extends MUIButtonProps {
	loading?: boolean;
}

const StyledButton = styled(MUIButton)(
	({ theme: { palette, } /* , variant */ }) => ({
		fontSize: '.875rem',
		textTransform: 'none',
		minHeight: '0rem',
		minWidth: '0rem',
		padding: '0.25rem .75rem',
		fontWeight: '500',
		lineHeight: '1.25rem',
		letterSpacing: '-0.01875rem',

		'&.MuiButton-startIcon': {
			backgroundColor: 'red'
		},

		'&.MuiButton-contained': {
			backgroundColor: palette.theme?.primary[700],
			// boxShadow: '0px 0px 2px 0px #E0E0E0, 0px 1px 4px -2px rgba(24, 39, 75, 0.02), 0px 4px 4px -2px rgba(24, 39, 75, 0.06)',
			'&:hover': {
				backgroundColor: palette.theme?.primary[800]
			}
		},

		'&.MuiButton-outlined': {
			border: 'none',
			boxShadow: '0px 0px 2px 0px #E0E0E0, 0px 1px 4px -2px rgba(24, 39, 75, 0.02), 0px 4px 4px -2px rgba(24, 39, 75, 0.06)',
			color: palette.theme?.primary[700]
		},

		'&.MuiButton-text': {
			color: palette.theme?.secondary[1000],
			backgroundColor: 'white',
			'&:hover': {
				color: palette.theme?.primary[700]
			},
			'& .MuiButton-startIcon': {
				// background: palette.theme?.primary[400],
			}
		},

		'&.MuiButton-containedError': {
			backgroundColor: palette.theme?.error[500],
			'&:hover': {
				backgroundColor: palette.theme?.error[600]
			}
		},

		'&.Mui-disabled': {
			opacity: 0.5
		}
	})
);

const Button = (props: ButtonProps) => {
	const { children, variant = 'contained', loading = false, disabled, ...rest } = props;

	return (
		<StyledButton
			variant={variant}
			disabled={disabled || loading}
			{...(loading && { endIcon: <CircularProgress size={18} color='inherit' /> })}
			{...rest}
		>
			{children}
		</StyledButton>
	);
};

export { Button };
export default Button;
